import React from 'react';
import {useTranslation} from 'react-i18next';
import AsyncSelect from 'react-select/async';
import {SelectStructure} from '../SelectStructure';

const rootElement = document.getElementById('root');
const defaultMenuProps = {
    menuPortalTarget: rootElement,
    menuPosition: 'fixed',
    maxMenuHeight: 300,
};
export function RawAsyncSelect({
    label,
    type,
    prefix,
    loadOptions,
    defaultValue,
    onChange,
    disabled,
    reloadProp,
    autoLoadOptions,
    placeholder,
    unsetPortal,
    menuHeight,
    ...props
}) {
    const {t} = useTranslation();
    const menuProps = unsetPortal
        ? {}
        : {...defaultMenuProps, maxMenuHeight: menuHeight || defaultMenuProps.maxMenuHeight};

    return (
        <SelectStructure type={type} prefix={prefix} label={label} disabled={disabled}>
            <div>
                <AsyncSelect
                    {...props}
                    placeholder={placeholder || t('searchableDropdown.placeholder')}
                    classNamePrefix="dropdown-select"
                    loadOptions={loadOptions}
                    defaultOptions={autoLoadOptions}
                    defaultValue={defaultValue}
                    onChange={onChange}
                    key={JSON.stringify(reloadProp)}
                    isDisabled={disabled}
                    menuPosition={'fixed'}
                    {...menuProps}
                    styles={{
                        menu: (base) => ({
                            ...base,
                            zIndex: 9999,
                            position: 'absolute',
                            overflow: 'scroll',
                            marginTop: '1px',
                            height: 'auto',
                        }),
                        menuPortal: (base) => ({
                            ...base,
                            zIndex: 9999,
                        }),
                    }}
                />
            </div>
        </SelectStructure>
    );
}
